<template>
    <div>
        <HeaderComponent :pageContent="pageHeader" @change_language="handleHeaderClick"></HeaderComponent>
        <div class="container py-4">
            <div class="row">
                <div class="col-md-7">
                    <h2 class="fw-bold mb-2 colorText">Lesson Planning & Curriculum Resources</h2>
                    <hr class="hr">
                </div>

                <div class="col-md-12">
                    <p class="colorText mb-4">
                        Explore curated collection of trusted platforms offering ready-to-use lessons, units, and interactive materials. These tools support curriculum development and
enhance classroom instruction with standards-aligned content across subjects.
                    </p>
                </div>
            </div>


            <div class="row g-4 px-4">
                <!-- Edulastic -->
                <div class="col-md-6">
                    <div class="platform-card shadow-sm">
                        <a href="https://www.teacherspayteachers.com/" class="flex-shrink-1" target="_blank">
                            <img src="/assets/images/lesson-planning-curriculum/1.png" alt="Edulastic" />
                        </a>
                        <div class="flex-grow-1">
                            <h6 class="fw-bold mb-1 colorText">Teachers Pay Teachers</h6>
                            <p class="mb-2 small colorText">
                                Peer-created lessons, activities and resources for all grade levels.
                            </p>
                            <div class="d-flex justify-content-end">
                                <a href="https://www.teacherspayteachers.com/" target="_blank" class="btn btn-primary btn-sm">Visit Site</a>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Formative -->
                <div class="col-md-6">
                    <div class="platform-card shadow-sm">
                        <a href="https://www.readwritethink.org/" class="flex-shrink-1" target="_blank">
                            <img src="/assets/images/lesson-planning-curriculum/2.png" alt="Formative" />
                        </a>
                        <div class="flex-grow-1">
                            <h6 class="fw-bold mb-1 colorText">ReadWriteThink</h6>
                            <p class="mb-2 small colorText">
                                Free ELA lesson plans, printables, and interactive tools aligned to literacy standards.
                            </p>
                            <div class="d-flex justify-content-end">
                                <a href="https://www.readwritethink.org/" target="_blank" class="btn btn-primary btn-sm">Visit Site</a>
                            </div>
                        </div>
                    </div>
                </div>




                <!-- Blooket -->
                <div class="col-md-6">
                    <div class="platform-card shadow-sm">
                        <a href="https://www.khanacademy.org/" class="flex-shrink-1" target="_blank">
                            <img src="/assets/images/lesson-planning-curriculum/3.png" alt="Blooket" />
                        </a>
                        <div class="flex-grow-1">
                            <h6 class="fw-bold mb-1 colorText">Khan Academy</h6>
                            <p class="mb-2 small colorText">
                                Offers free, standards-aligned lessons and practice in math, science, ELA, history, and more, with personalized learning pathways
                            </p>
                            <div class="d-flex justify-content-end">
                                <a href="https://www.khanacademy.org/" target="_blank" class="btn btn-primary btn-sm">Visit Site</a>
                            </div>
                        </div>
                    </div>
                </div>


                <!-- Kahoot -->
                <div class="col-md-6">
                    <div class="platform-card shadow-sm">
                        <a href="https://www.ck12.org/" class="flex-shrink-1" target="_blank">
                            <img src="/assets/images/lesson-planning-curriculum/4.png" alt="Kahoot" />
                        </a>
                        <div class="flex-grow-1">
                            <h6 class="fw-bold mb-1 colorText">CK-12 Foundation</h6>
                            <p class="mb-2 small colorText">
                                Provides free digital textbooks (FlexBooks),
simulations, and interactive lessons in math and science.
                            </p>
                            <div class="d-flex justify-content-end">
                                <a href="https://www.ck12.org/" target="_blank" class="btn btn-primary btn-sm">Visit Site</a>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Quizizz -->
                <div class="col-md-6">
                    <div class="platform-card shadow-sm">
                        <a href="https://www.commonlit.org/" class="flex-shrink-1" target="_blank">
                            <img src="/assets/images/lesson-planning-curriculum/5.png" alt="Quizizz" />
                        </a>
                        <div class="flex-grow-1">
                            <h6 class="fw-bold mb-1 colorText">CommonLit</h6>
                            <p class="mb-2 small colorText">
                                Offers free, standards-aligned lessons and practice in math, science, ELA, history, and more, with personalized learning pathways
                            </p>
                            <div class="d-flex justify-content-end">
                                <a href="https://www.commonlit.org/" target="_blank" class="btn btn-primary btn-sm">Visit Site</a>
                            </div>
                        </div>
                    </div>
                </div>


                <!-- Google Forms -->

                <div class="col-md-6">
                    <div class="platform-card shadow-sm">
                        <a href="https://www.education.com/" class="flex-shrink-1" target="_blank">
                            <img src="/assets/images/lesson-planning-curriculum/6.png" alt="Google Forms" />
                        </a>
                        <div class="flex-grow-1">
                            <h6 class="fw-bold mb-1 colorText">Education.com</h6>
                            <p class="mb-2 small colorText">
                                Printable worksheets, lesson plans and games across subjects, grades Pre-K through 6.
                            </p>
                            <div class="d-flex justify-content-end">
                                <a href="https://www.education.com/" target="_blank" class="btn btn-primary btn-sm">Visit Site</a>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="col-md-6">
                    <div class="platform-card shadow-sm">
                        <a href="https://sharemylesson.com/" class="flex-shrink-1" target="_blank">
                            <img src="/assets/images/lesson-planning-curriculum/7.png" alt="Google Forms" />
                        </a>
                        <div class="flex-grow-1">
                            <h6 class="fw-bold mb-1 colorText">Share My Lesson</h6>
                            <p class="mb-2 small colorText">
                                Free lesson plans and resources created by educators, including collections for SEL, DEI, and current events.
                            </p>
                            <div class="d-flex justify-content-end">
                                <a href="https://sharemylesson.com/" target="_blank" class="btn btn-primary btn-sm">Visit Site</a>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="col-md-6">
                    <div class="platform-card shadow-sm">
                        <a href="https://www.theteacherscorner.net/" class="flex-shrink-1" target="_blank">
                            <img src="/assets/images/lesson-planning-curriculum/8.png" alt="Google Forms" />
                        </a>
                        <div class="flex-grow-1">
                            <h6 class="fw-bold mb-1 colorText">The Teacher's Corner</h6>
                            <p class="mb-2 small colorText">
                                Weekly lesson plan templates, thematic units, and seasonal activities for elementary and middle school.
                            </p>
                            <div class="d-flex justify-content-end">
                                <a href="https://www.theteacherscorner.net/" target="_blank" class="btn btn-primary btn-sm">Visit Site</a>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>




        <FooterComponent :pageContent="pageFooter"></FooterComponent>
    </div>
</template>
<style>
.colorText {
    color: #0c27bd;
}

.hr {
    border: 1px solid #0d6efd;
    border-radius: 5px;
}

.platform-card {
    border-radius: 12px;
    padding: 1rem;
    background-color: #ffff;
    display: flex;
    align-items: center;
    gap: 1rem;
}

/* .platform-card img {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    object-fit: contain;
} */

.platform-card img {
    width: 60px;
    height: 60px;
    min-width: 60px;
    min-height: 60px;
    max-width: 60px;
    max-height: 60px;
    border-radius: 8px;
    object-fit: contain;
    flex-shrink: 0;
}


.platform-card .btn {
    font-size: 0.85rem;
    padding: 0.3rem 0.75rem;
}
</style>
<script>
// @ is an alias to /src
import HeaderComponent from "@/components/HeaderComponent.vue";
import FooterComponent from "@/components/FooterComponent.vue";
import globalMixins from "@/plugins/globalMixins";

export default {
    name: "lesson-planning-and-curriculum-resources",
    components: {
        HeaderComponent,
        FooterComponent,
    },
    data() {
        return {
            pageContent: [],
            pageHeader: [],
            pageFooter: [],
        }
    },
    mounted() {
        const storedLanguage = localStorage.getItem("language");
        if (storedLanguage) {
            this.language = storedLanguage;
        }
        this.convertLanguage();
    },
    methods: {
        openModal(url) {
            console.log(url);
            this.videoUrl = url;
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
            this.videoUrl = "";
        },
        handleHeaderClick() {
            this.convertLanguage();
        },
        async convertLanguage() {
            const storedLanguage = localStorage.getItem("language");
            if (storedLanguage) {
                this.language = storedLanguage;
            }

            let lang = this.language;
            if (lang === "us") {
                lang = "en";
            }

            console.log("Updated content:", lang);

            const converted = globalMixins.class_room[lang];

            const pageHeader = globalMixins.pageHeader[lang];

            const pageFooter = globalMixins.pageFooter[lang];

            if (converted) {
                this.pageContent = {
                    ...this.pageContent,
                    ...converted,
                };

                this.pageHeader = {
                    ...this.pageHeader,
                    ...pageHeader,
                };

                this.pageFooter = {
                    ...this.pageFooter,
                    ...pageFooter,
                };
            }
        },
    },

};
</script>